import { Global, Collection } from '@sourceflow-uk/sourceflow-sdk';
import SeoHead from '../../../components/SeoHead';
import MainBanner from '../../../components/MainBanner';
import ImageWithTextBanner from '../../../components/ImageWithTextBanner';
import GetInTouch from '../../../components/GetInTouch';
import AccordionColumnBox from '../../../components/AccordionColumnBox';
import Link from "next/link"

export default function ContractorsPage({
    global,
    all_contractor_benefits
}) {
    return (
        <>
            <SeoHead
                page_name={`Contractors | Science, Engineering & Life Science Recruitment, Jobs & Staffing | SRG | United States`}
                canonical_link={`contractors`}
                en_gb={false}
                en_us={true}
            />
            <MainBanner
                global={global}
                pathPrefix={`us.contractors_page.main_banner`}
                customClass={``}
                content={
                    <>
                        <h1>Contractors</h1>
                    </>
                }
                imageURL1={`/site-assets/images/main-banner.jpg`}
                imageALT1={`Main Banner`}
                imageURL2={`/site-assets/images/main-banner-overlay.jpg`}
                imageALT2={`Overlay Main Banner`}
            />
            <AccordionColumnBox
                global={global}
                pathPrefix={`us.contractors_page.accordion_column_box`}
                customClass={`pt-5 grayGradientBg`}
                content={
                    <>
                        <h2>Contractor Benefits</h2>
                    </>
                }
                post={all_contractor_benefits}
            />
            <GetInTouch
                global={global}
                pathPrefix={`us.contractors_page.get_in_touch`}
                customClass={`py-5`}
                content={
                    <>
                        <h2>Get in Touch!</h2>
                        <p>Unresolved query? Let us help. Get in touch with the Lorien Contractor and Candidate Support Team to find answers quickly, from information on payments to how to submit your timesheets. No matter how big or small the question, no matter how new or experienced you are to the world of contracting, we'll do our best to give you up-to-date, informed, and helpful answers about working through Lorien as a contractor.</p>
                        <h5>Our hotlines are:</h5>
                    </>
                }
                hard_coded_contacts={
                    <>
                        <p>
                            <Link href={`mailto:enquiries@srgtalent.com`}>
                                <a>
                                    enquiries@srgtalent.com
                                </a>
                            </Link>
                        </p>

                    </>
                }
                content_2={``}
                buttonLink={``}
                buttonTitle={``}
                content_3={
                    <>
                        <p>For all other enquiries, please complete our form or reach out to us on <a href="tel:02039109446">02039109446</a>. </p>
                    </>
                }
                formId={`54cf1145-7b66-4ce9-8a05-f0e9da9038d0`}
                successPageUrl={`/contractors/submission-success/`}
            />
            <ImageWithTextBanner
                global={global}
                pathPrefix={`us.contractors_page.image_with_text_banner`}
                customClass={``}
                content={
                    <>
                        <h2>Contractor Portal</h2>
                        <p>The Contractor Portal is your single repository for logging timesheets and raising invoices.</p>
                    </>
                }
                imageURL={`/site-assets/images/contractors-image.jpg`}
                imageALT={`Job Seekers Featured Image`}
                buttonLink={`https://ess.impellam.com/`}
                buttonTitle={`Login`}
                newPageTab={true}
            />
            <ImageWithTextBanner
                global={global}
                pathPrefix={`us.contractors_page.image_with_text_banner.2`}
                customClass={``}
                content={
                    <>
                        <h2>Employment and Income Verification</h2>
                        <p>Vertage works with Certree for all employment and income verifications. Past and current employees should visit <a href="https://certree.com/" target="_blank">www.certree.com</a> and create a profile. Once they create a profile, they can generate a free and secure link with their employment and/or income details that can be provided to the person or organization requesting the verification. This site is available 24 hours a day, seven days a week.</p>
                        <p>For other questions about past employment with Vertage and any of our brands (BarPellam, Bartech, Guidant Global, Lorien, or SRG), please contact our <a href="mailto:HR-InfoImpellamNA@impellam.com">People Team</a>.</p>
                    </>
                }
                imageURL={`/site-assets/images/centree-trust.png`}
                imageALT={`Employment and Income Verification Image`}
                buttonLink={`https://certree.com/`}
                buttonTitle={`Read More`}
                newPageTab={true}
                inverted={true}
            />
        </>
    )
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();
    const contractor_benefits = await Collection('contractor_benefits');

    const all_contractor_benefits = contractor_benefits.orderBy('_order').getItems();
    return {
        props: {
            global,
            all_contractor_benefits
        }
    };
}
